@if (!removeNav) {
	<header class="navbar navbar-expand-xl">
		<nav class="container-fluid">
			<a href="javascript:void(0)" (click)="goSmartBegin()" class="navbar-brand" id="topNavLogoLink">
				<img [attr.src]="logo" [attr.alt]="agentName" class="top-logo" />
			</a>
			@if (!useAltHeader || isLoggedIn) {
				<button class="navbar-toggler" type="button" (click)="openCanvas(canvasContent)">
					<fa-icon [icon]="['fas', 'bars']"></fa-icon>
				</button>
				<ng-template #canvasContent let-offcanvas>
					<div class="offcanvas-header">
						<span class="offcanvas-title" id="offcanvasNavbarLabel">
							<button type="button" class="btn-close text-reset" (click)="offcanvas.close('Close click')" aria-label="Close"></button>
						</span>
					</div>
					<div class="offcanvas-body">
						<pkd-navbar-nav [useAltHeader]="useAltHeader" (navigated)="offcanvas.close('Navigated')"></pkd-navbar-nav>
					</div>
				</ng-template>
				<div class="offcanvas">
					<pkd-navbar-nav [useAltHeader]="useAltHeader" class="offcanvas-body"></pkd-navbar-nav>
				</div>
			}
		</nav>
	</header>
}
